import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchPublicRooms } from '../services/partyScreenApi';
import RoomPasswordGate from '../components/RoomPasswordGate';
import './RoomSelect.css';

function StatusTag({ slideCount }) {
  if (slideCount > 0) {
    return <span className="rs-tag rs-tag--green">{slideCount} 张投屏</span>;
  }
  return <span className="rs-tag">待配置</span>;
}

export default function RoomSelect() {
  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [pendingRoom, setPendingRoom] = useState(null);

  const loadRooms = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const list = await fetchPublicRooms();
      setRooms(Array.isArray(list) ? list : []);
    } catch (e) {
      setError(e?.message || '加载房间失败');
      setRooms([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadRooms();
  }, [loadRooms]);

  return (
    <div className="room-select-page">
      <RoomPasswordGate
        open={!!pendingRoom}
        roomName={pendingRoom?.name}
        onCancel={() => setPendingRoom(null)}
        onSuccess={() => {
          if (pendingRoom) navigate(`/room/${pendingRoom.id}`);
          setPendingRoom(null);
        }}
      />

      <div className="room-select-wrap">
        <div className="room-select-toolbar">
          <div className="room-select-toolbar-title">
            <h1>聚刻聚会 · 大屏</h1>
            <p>选择房间进入聚会大屏</p>
          </div>
          <button type="button" className="rs-btn rs-btn--default" onClick={loadRooms} disabled={loading}>
            刷新
          </button>
        </div>

        <div className="room-select-card">
          {loading ? (
            <div className="room-select-status">
              <span className="rs-spin" aria-hidden />
              加载房间中…
            </div>
          ) : error ? (
            <div className="room-select-status room-select-status--error">{error}</div>
          ) : rooms.length === 0 ? (
            <div className="room-select-status">暂无可用房间，请在管理后台配置</div>
          ) : (
            <div className="room-select-table-wrap">
              <table className="room-select-table">
                <thead>
                  <tr>
                    <th>门店</th>
                    <th>房间</th>
                    <th>容量</th>
                    <th>入场时间</th>
                    <th>投屏状态</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  {rooms.map((room) => (
                    <tr key={room.id}>
                      <td className="rs-cell-ellipsis" title={room.store_name || '—'}>
                        {room.store_name || '—'}
                      </td>
                      <td>{room.name}</td>
                      <td>{room.capacity ? `${room.capacity} 人` : '—'}</td>
                      <td>
                        {room.entry_time ? (
                          <span className="rs-tag rs-tag--blue">{room.entry_time}</span>
                        ) : (
                          '—'
                        )}
                      </td>
                      <td>
                        <StatusTag slideCount={room.slide_count} />
                      </td>
                      <td>
                        <button
                          type="button"
                          className="rs-link-btn"
                          onClick={() => setPendingRoom({ id: room.id, name: room.name })}
                        >
                          进入大屏
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="room-select-table-footer">共 {rooms.length} 条</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
